import { QueryOptions, queryOptions, useMutation } from '@tanstack/react-query';
import { service } from '@maia/customer';

export type Customer = Awaited<ReturnType<(typeof service)['getCustomer']>>;

export function getCustomerOptions(
  guid: string,
  initialData: QueryOptions<Customer>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['customers', 'customer', guid],
    queryFn: async () => await service.getCustomer(guid),
    initialData,
  });
}

type UseUpdateIbanParams = Parameters<typeof service.updateIban>[number];

export function useUpdateIban(
  customerGuid: string,
  onSuccess: () => void,
  onError: () => void,
) {
  return useMutation({
    mutationFn: (param: UseUpdateIbanParams['body']) =>
      service.updateIban({
        body: param,
        customerGuid,
      }),
    onSuccess,
    onError,
  });
}

type UseUpdateBillingParams = Parameters<
  typeof service.updateBillingCycle
>[number];

export function useUpdateBillingCycle(
  customerGuid: string,
  onSuccess: () => void,
  onError: () => void,
) {
  return useMutation({
    mutationFn: (param: UseUpdateBillingParams['body']) =>
      service.updateBillingCycle({
        body: param,
        customerGuid,
      }),
    onSuccess,
    onError,
  });
}
